<div class="file-upload">
  <div class="row upload-all-files">
    <div>
      <h5 class="upload-section-text">
        {{ "help.feedbackupload" | cxTranslate }} 
      </h5>

      <div class="col-md-7">
        <div>
          <label class="custom-upload" [ngClass]="{'disabled-btn' : disbledBtn}" for="demofile-notify">
            <input

              class="hidden upload-input"
              multiple
              id="demofile-notify"
              type="file"
              (change)="upload($event)"
            />
            <em class="material-icons custom-upload-icon">backup</em>
            <span>  {{ "help.uploadfile" | cxTranslate }} </span>
          </label>
        </div>
        
      </div>
    </div>
    
  </div>
  <div class="row custom-file-format-width">
    <div class="col-md-12 custom-margin-bottom">
      <h5 class="upload-section-text custom-file-type-margin">
        {{ "help.fileformat" | cxTranslate }} 
      </h5>
    </div>
  </div>

 
    <div id="docInnerNotify" class="section-document">
      <div id="fileInfo-notify" #fileInfoNotify class="fileInfo-section"></div>
      <p
        class="section-document-document-details error-msg"
        id="fileMaxLenghtExceednotify" #fileMaxLenghtExceednotify
      ></p>
      <p
        id="fileSizeExceedNotify" #fileSizeExceedNotify
        class="section-document-document-details error-msg"
      ></p>
      <p id="fileTypeNotify" #fileTypeNotify class="section-document-document-details error-msg"></p>
      <p
        id="fileDuplicateNotify" #fileDuplicateNotify
        class="section-document-document-details error-msg"
      ></p>
      <p
      id="filenameLengthNotify"
      #filenameLengthNotify
      class="section-document-document-details error-msg"
    ></p>
  </div>
</div>